/**
 * Calls `pendo.identify(...)` to upgrade an anonymous Pendo session to an identified one.
 *
 * PRECONDITION: `window.pendo.initialize({})` must have been called earlier in the page
 * lifecycle (typically in the App component's `mounted()` hook). `identify()` is a no-op
 * if the Pendo agent has not been initialized.
 *
 * Companion helper to `notifyPendo.js` (which calls `initialize(visitor, account)` directly).
 * @param {object} user - authenticated user object with `pendoVisitor` and optional `pendoAccount`
 */
function identifyPendo(user) {
  if (!user || !window.pendo) return;

  const pendoVisitor = {
    ...user.pendoVisitor,
    language: (navigator.language || "").split("-")[0] || "en",
  };
  const pendoAccount = user.pendoAccount;

  if (pendoAccount) {
    window.pendo.identify({ visitor: pendoVisitor, account: pendoAccount });
  } else {
    window.pendo.identify({ visitor: pendoVisitor });
  }
}

export default identifyPendo;
